import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { of } from "rxjs";
import { ToastService } from "./toast.service";
import { ShadowConstraint } from "../models/shadowConstraint.model";
import { Enum } from "../models/enum.model";
import { GridService, IGridService } from "../shared/grid/grid.service";

@Injectable({
    providedIn: "root",
})
export class ShadowConstraintService extends GridService<ShadowConstraint> {
    constructor(
        httpClient: HttpClient,
        private toastService: ToastService,
    ) {
        super("ShadowConstraint", httpClient);
    }

    getConstraintTypes() {
        return this.http
            .get<Enum[]>(this.getApiUrl("ShadowConstraint/GetConstraintTypes"))
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading constraint types",
                        true,
                    );
                    return of([]);
                }),
            );
    }

    getOperatorTypes() {
        return this.http
            .get<Enum[]>(this.getApiUrl("ShadowConstraint/GetOperatorTypes"))
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading operator types",
                        true,
                    );
                    return of([]);
                }),
            );
    }
}
